import { type Dispatch, type MutableRefObject, type SetStateAction, useEffect } from 'react'

/** Clears the "Z held" marquee-zoom flag when Z is released or the window loses focus. */
export function useZMarqueeKeyRelease({
  isEditableTarget,
  zMarqueeKeyHeldRef,
  setZMarqueeKeyHeld,
}: {
  isEditableTarget: (target: EventTarget | null) => boolean
  zMarqueeKeyHeldRef: MutableRefObject<boolean>
  setZMarqueeKeyHeld: Dispatch<SetStateAction<boolean>>
}) {
  // Release “Z held” for marquee zoom on keyup / window blur (drag may continue via pointer capture).
  useEffect(() => {
    const clearZMarqueeHeld = () => {
      zMarqueeKeyHeldRef.current = false
      setZMarqueeKeyHeld(false)
    }

    const onKeyUp = (e: KeyboardEvent) => {
      if (e.key !== 'z' && e.key !== 'Z') return
      if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) return
      if (isEditableTarget(e.target)) return
      clearZMarqueeHeld()
    }

    window.addEventListener('keyup', onKeyUp)
    window.addEventListener('blur', clearZMarqueeHeld)

    return () => {
      window.removeEventListener('keyup', onKeyUp)
      window.removeEventListener('blur', clearZMarqueeHeld)
    }
  }, [isEditableTarget, zMarqueeKeyHeldRef, setZMarqueeKeyHeld])
}
